<div>
    <ion-grid class="full-w padding-xs">

        <ion-row *ngIf="titleDisp" class="center-text">
            <ion-col>
                <div [innerHTML]="titleDispKey | i18next" class="info-text-m bold description-frame text-color-primary center-text">
                </div>
            </ion-col>
        </ion-row>

        <ion-row *ngIf="descriptionDisp" class="text-left">
            <ion-col>
                <div [innerHTML]="descriptionDisp" class="info-text-m description-frame text-color-primary text-left">
                </div>
            </ion-col>
        </ion-row>

        <!-- <ion-row *ngIf="promo">
            <ion-col size="12">
                <span class="info-text-s center-text">{{getPromoDisp()}}</span>                
            </ion-col>
        </ion-row>   -->

        <ion-row>
            <ion-col size="12">
                <ion-button class="action-button-fill-large button-color-alternate" (click)="tapCheckout()">
                    <!-- <span class="button-font-size-s padding-horizontal-s">{{checkoutDisp}}</span> -->
                    <ion-row class="full-w center-items">
                        <ion-col size="4">
                            <!-- slot="start" class="slot-icon-padding" -->
                            <icon-wrapper [icon]="appIcons.secureCheckout" [custom]="true" [huge]="true">
                            </icon-wrapper>
                        </ion-col>
                        <ion-col size="4">
                            <span class="button-font-size-m padding-horizontal-s">{{'connect:labels.bookNow' | i18next}}</span>
                        </ion-col>
                        <ion-col size="4">
                            <div class="flex-col padding-left-s">
                                <span *ngIf="!promo" class="info-text-s bold">{{price}}</span>
                                <span *ngIf="promo" class="info-text-xs text-strikethrough">{{price}}</span>
                                <span *ngIf="promo" class="info-text-s bold">{{promo}}</span>
                            </div>
                        </ion-col>
                    </ion-row>
                </ion-button>

                <!-- <ion-button [disabled]="!placeUrl"
                    class="as-text element-selector info-text-s text-color-primary text-center"
                    (click)="goToReference()">
                    <span class="button-font-size-xs">{{'connect:labels.visitWebsite' | i18next}}</span>
                    <icon-wrapper slot="start" [icon]="appIcons.www" [custom]="true" class="slot-icon-padding">
                    </icon-wrapper>
                </ion-button> -->

            </ion-col>
        </ion-row>

        <div *ngIf="!noLogo" class="text-center margin-bottom-s">
            <img [src]="stripeBadge" height="40" class="padding-top-s">
        </div>

        <ion-row *ngIf="footerDisp" class="text-center">
            <div [innerHTML]="footerDispKey | i18next" class="info-text-s description-frame text-color-primary full-w"></div>
        </ion-row>

    </ion-grid>
</div>